import ComparisonResultData from '../../../entities/ComparisonResultData'
import ComparisonResultCategory from '../../../entities/ComparisonResultCategory'

const filterCategoriesBySelection = (
    resultData: ComparisonResultData | undefined,
    selectedCategories: Set<string>,
): ComparisonResultCategory[] => {
    if (!resultData?.categories) {
        return []
    }

    return resultData.categories.filter(category => {
        if (category.id === 'model') {
            return true
        }
        return selectedCategories.has(category.id)
    })
}

export default filterCategoriesBySelection
